// OWNER: FRONTEND-ADMIN. NANP phone helpers (pure). The server normalises again; this is for instant feedback.

/** '(416) 555-1234', '416.555.1234', '+1 416 555 1234' → { e164: '+14165551234', display: '(416) 555-1234' }.
 *  Returns null for anything that isn't a valid NANP number (NPA and NXX may not start with 0 or 1). */
export function normalizeNanp(input: string): { e164: string; display: string } | null {
  const trimmed = input.trim();
  if (!trimmed || /[a-z]/i.test(trimmed)) return null; // letters (incl. 'ext 12') → not a plain number
  let digits = trimmed.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
  if (digits.length !== 10) return null;
  if (!/^[2-9]\d{2}[2-9]\d{6}$/.test(digits)) return null;
  return { e164: '+1' + digits, display: `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}` };
}

/** '+14165551234' → '(416) 555-1234'; anything else is returned unchanged. */
export function formatPhone(e164: string | null | undefined): string {
  if (!e164) return '—';
  const m = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164);
  return m ? `(${m[1]}) ${m[2]}-${m[3]}` : e164;
}

/** Spoken form for a script: '416-555-1234'. */
export function spokenPhone(e164: string): string {
  const m = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164);
  return m ? `${m[1]}-${m[2]}-${m[3]}` : e164;
}
